import { RouteGroup } from '@Constants/routes';
import ScratchCards from '../PromoCodes';
import GenerateCodes from '../components/GenerateCode';
import { UpdatePromoCode } from '../Pages/UpdatePromoCode/UpdatePromoCode';
import { UsageTable } from '../components/UsageTable/UsageTable';

export const PromoCodesRoute: RouteGroup = {
	isRouted: true,
	title: 'Promo Codes',
	route: 'promo-codes',
	icon: 'local_offer',
	// Promocodes' own view code (was borrowing the scratchcards' v-schc; the
	// backend migration backfills v-prm to every v-schc-holding role).
	code: 'v-prm',
	component: <ScratchCards />,
	routes: [
		{
			route: 'create',
			component: <GenerateCodes />,
			title: '',
			code: '',
			offMenu: true,
		},
		{
			route: 'update/:id',
			component: <UpdatePromoCode />,
			title: '',
			code: '',
			offMenu: true,
		},
		{
			route: ':id',
			component: <UsageTable />,
			title: '',
			code: '',
			offMenu: true,
		},
	],
};
